import React, { useState, useEffect } from "react";

const PointGeo = ({ geo }) => {
  let pos = geo.percent ?? 0;
  return (
    <>
      <span
        className={"position-absolute translate-middle rounded-circle " + (geo.is_base ? 'bg-black':'bg-secondary')}
        style={{ width: "10px", height: "10px", top: "2px", left: `${pos}%`, zIndex: 1000, }}
      ></span>
      <small
        className={"position-absolute rotated fw-bold " + (geo.is_base ? 'text-black':'text-muted')}
        style={{ width: '100px', top: "17px", left: `${pos + 1}%` }}
      >
        {geo?.name ?? "-"}
      </small>
    </>
  );
};
export default PointGeo;
